export default __webpack_public_path__ + "static/media/ic_matic_40.941ecb5c.svg";